import { useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import countries from '../utils/Countries';
import '../assets/leadlist.css';
import LeadModal from './LeadModal';
import AddUserModal from './AddUserModal'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import { useEffect } from 'react';
import Select from 'react-select';
import ExcelUpload from './ExcelUpload';
import ExcelExport from './ExcelExport';


function LeadList({ leads, users, role, user, isAdmin, onSave, onSaveUser, onDelete, onAdd, onExcelUpload, onRefresh, token }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [leadsPerPage, setLeadsPerPage] = useState(null);
  const [searchPhone, setSearchPhone] = useState('');
  const [searchName, setSearchName] = useState('');
  const [searchEmail, setSearchEmail] = useState('');
  const [selectedStatusFilter, setSelectedStatusFilter] = useState('');
  const [selectedSourceFilter, setSelectedSourceFilter] = useState('');
  const [selectedManagerFilter, setSelectedManagerFilter] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [editData, setEditData] = useState({});
  const [showUserModal, setShowUserModal] = useState(false);
  const [userData, setUserData] = useState({});
  const [adding, setAdding] = useState(false);
  const [newLeadData, setNewLeadData] = useState({});
  const [showModal, setShowModal] = useState(false);  
  const [columns, setColumns] = useState([
    { id: 'index', label: '№' }, 
    isAdmin && { id: 'actions', label: 'Действия' },
    { id: 'attention', label: 'Внимание' },
    { id: 'manager', label: 'Менеджер' },  
    { id: 'telefon', label: 'Телефон' },
    { id: 'email', label: 'Email' },   
    { id: 'name', label: 'Имя' },     
    { id: 'status', label: 'Статус', width: '160px' },
    { id: 'kommentarOperator', label: 'Комментарий оператора', width: '480px' },    
    { id: 'kommentarsKonto', label: 'Комментарий к аккаунту', width: '480px' },       
    { id: 'country', label: 'Страна' },
    { id: 'source', label: 'Источник' },
    { id: 'datetime', label: 'Дата и время' }
  ]); 

  const statusOptions = [
    { value: 'New', label: 'New', color: '#92ef73' },
    { value: 'NA', label: 'NA', color: '#d873ef' },
    { value: 'NI', label: 'NI', color: '#73d6ef53' },
    { value: 'Wrong', label: 'Wrong', color: '#ef7381' },
    { value: 'Unaviable', label: 'Unaviable', color: '#3483f1' },
    { value: 'Depositor', label: 'Depositor', color: '#efb573' },
    { value: 'VM', label: 'VM', color: '#73e3ef' },
    { value: 'HU', label: 'HU', color: '#ec4e4e80' },
    { value: 'Callback', label: 'Callback', color: '#ffeb3b' },
    { value: 'Replace', label: 'RP', color: '#fc0808' },
    { value: 'Double', label: 'Double', color: '#fc0808' },
    { value: 'NoLanguage', label: 'No Language', color: '#6c8267ff' }
  ];

// Универсально достаём id из разных форм (id/Id/userId/UserId)
const getAnyId = (obj) =>
  obj ? (obj.id ?? obj.Id ?? obj.userId ?? obj.UserId ?? null) : null;

// Единая проверка прав с нормализацией типов
const isAdminUser = Boolean(isAdmin || user?.role === 'admin');

const canEdit = (lead) => {
  const uid = getAnyId(user);
  const mid = lead?.managerId ?? getAnyId(lead?.manager); // сначала managerId, потом manager.id
  if (isAdminUser) return true;
  if (uid == null || mid == null) return false; // нет одного из ID
  return String(uid) === String(mid); // сравниваем как строки — не спотыкаемся о типы
};


const customStyles = {
    option: (provided, state) => ({
      ...provided,
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
    }),
    singleValue: (provided, state) => ({
      ...provided,
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
    }),
  };

  const formatOptionLabel = ({ label, color }) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <span
        style={{
          display: 'inline-block',
          width: 10,
          height: 10,
          borderRadius: '50%',
          backgroundColor: color,
        }}
      ></span>
      {label}
    </div>
  );

  const [managers, setManagers] = useState([]);

  useEffect(() => {
  if (users && users.length > 0) {
    setManagers(users.filter(u => u.role === 'admin' || u.role === 'user'));
  }
}, [users]); 

    const handleExcelExport = async () => {
    try {
      //const path = 'http://localhost:5000/api/import/export';
      const path = 'https://sdtxt.top/api/import/export';
      const response = await fetch(path, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Ошибка при экспорте файла');
      }
      debugger;
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;

      const disposition = response.headers.get('Content-Disposition');
      let fileName = 'export.xlsx';

      if (disposition) {
        // Попробуем сначала вытащить filename* (RFC 5987)
        let match = disposition.match(/filename\*=UTF-8''([^;\n]+)/i);
        if (match && match[1]) {
          fileName = decodeURIComponent(match[1]);
        } else {
          // Фолбэк на обычный filename=
          match = disposition.match(/filename="?([^"]+)"?/i);
          if (match && match[1]) {
            fileName = match[1];
          }
        }
      }

      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Ошибка экспорта:', err);
    }
  };


  const handleSort = (key) => {
  let direction = 'asc';
  if (sortConfig.key === key && sortConfig.direction === 'asc') {
    direction = 'desc';
  }
  setSortConfig({ key, direction });
};

const filteredLeads = leads.filter((lead) => {
  const statusMatch = !selectedStatusFilter || lead.status === selectedStatusFilter;
  const sourceMatch = !selectedSourceFilter || lead.source === selectedSourceFilter;
  const managerMatch = !selectedManagerFilter || lead.managerId === parseInt(selectedManagerFilter);
  const phoneMatch = !searchPhone || lead.telefon?.toLowerCase().includes(searchPhone.toLowerCase());
  const nameMatch = !searchName || lead.name?.toLowerCase().includes(searchName.toLowerCase());
  const emailMatch = !searchEmail || lead.email?.toLowerCase().includes(searchEmail.toLowerCase());
  return statusMatch && sourceMatch && phoneMatch && managerMatch && nameMatch && emailMatch;
});


const sortedLeads = [...filteredLeads].sort((a, b) => {
  // 1. Сначала — pinned
  const aPinned = a.isPinned ? 1 : 0;
  const bPinned = b.isPinned ? 1 : 0;

  if (aPinned !== bPinned) {
    // bPinned - aPinned => true (1) пойдёт раньше
    return bPinned - aPinned;
  }

  // 2. Если pin одинаковый — твоя старая логика
  if (!sortConfig.key) return 0;

  const aValue =
    sortConfig.key === 'manager'
      ? a.manager?.name || ''
      : a[sortConfig.key] || '';

  const bValue =
    sortConfig.key === 'manager'
      ? b.manager?.name || ''
      : b[sortConfig.key] || '';

  return sortConfig.direction === 'asc'
    ? aValue.localeCompare(bValue)
    : bValue.localeCompare(aValue);
});


const indexOfLastLead = currentPage * leadsPerPage;
const indexOfFirstLead = indexOfLastLead - leadsPerPage;

const currentLeads =
  leadsPerPage !== null
    ? sortedLeads.slice(indexOfFirstLead, indexOfLastLead)
    : sortedLeads;

const totalPages = leadsPerPage !== null
  ? Math.ceil(sortedLeads.length / leadsPerPage)
  : 1;


const startAddUser = () => {
  setShowUserModal(true);  
  setUserData({ name: '', email: '', role: 'user', password: '' });  
};

const closeUserModal = () => {
  setShowUserModal(false);  
  setUserData({});  
};

const saveUser = async () => {
  setLoading(true);
  try {
    await onSaveUser(userData);  
    closeUserModal();  
  } catch (err) {
    console.error('Ошибка при добавлении пользователя:', err);
    setError('Ошибка при добавлении пользователя');
  } finally {
    setLoading(false);
  }
};


  const startEdit = (lead) => {
    setEditingId(lead.id);
    setEditData({ ...lead, managerId: lead.managerId || lead.manager?.id || '' });
    setError(null);
  };

  const cancelEdit = () => {
    setEditingId(null);
    setEditData({});
    setError(null);
  };

  const saveEdit = async () => {
    setLoading(true);
    setError(null);
    try {
      if (onRefresh) {
        console.log('⏳ Вызов onRefresh() после сохранения...');
        await onRefresh();
        console.log('✅ refreshLeads завершился');
      }

      await onSave(editData);
      setEditingId(null);
      setEditData({});
    } catch (err) {
      console.error('Ошибка при сохранении:', err);
      setError('Ошибка при сохранении');
    } finally {
      setLoading(false);
    }
  };

  const deleteLead = async (id) => {
    if (!window.confirm('Вы уверены, что хотите удалить лида?')) return;
    setLoading(true);
    setError(null);
    try {
      await onDelete(id);
    } catch (err) {
      console.error('Ошибка при удалении:', err);
      setError('Ошибка при удалении');
    } finally {
      setLoading(false);
    }
  };
  
  const startAdd = () => {
    setShowModal(true);  
    setNewLeadData({
      datetime: new Date().toISOString(),
      name: '',
      country: countries[0] || '',
      telefon: '',
      email: '',
      source: '',
      kommentarsKonto: '',
      status: 'New',
      kommentarOperator: ''
    });
    setError(null);
  };

  const closeModal = () => {
    setShowModal(false);  
    setNewLeadData({});
    setError(null);
  };

  const cancelAdd = () => {
    setAdding(false);
    setNewLeadData({});
    setError(null);
  };

  const saveAdd = async () => {
    setLoading(true);
    setError(null);
    try {
      await onAdd(newLeadData);
      closeModal(); 
    } catch (err) {
      console.error('Ошибка при добавлении:', err);
      setError('Ошибка при добавлении');
    } finally {
      setLoading(false);
    }
  };


  const getRowClass = (status) => {
      switch (status) {
        case 'New': return 'table-light';
        case 'NA': return 'table-secondary';
        case 'NI': return 'table-info';
        case 'Wrong': return 'table-danger';
        case 'Unaviable': return 'table-unaviable';
        case 'Depositor': return 'table-success';
        case 'VM': return 'table-warning';
        case 'HU': return 'table-primary';
        case 'Callback': return 'table-callback';
        case 'Replace': return 'table-replace';
        case 'Double': return 'table-replace';
        case 'NoLanguage': return 'table-abc';
        default: return '';
      }
    };

  const handleDragEnd = (result) => {
  if (!result.destination) return;

  const newColumns = Array.from(columns);
  const [moved] = newColumns.splice(result.source.index, 1);
  newColumns.splice(result.destination.index, 0, moved);
  setColumns(newColumns);
};


  return (
    <>
      {error && <p className="text-danger">{error}</p>}

      <div className="d-flex gap-2 align-items-end mb-3">
        <div>
          <label className="form-label">Поиск по телефону</label>
          <input
            type="text"
            className="form-control"
            placeholder="Введите номер"
            value={searchPhone}
            onChange={(e) => setSearchPhone(e.target.value)}
          />
        </div>

        <div>
          <label className="form-label">Поиск по имени</label>
          <input
            type="text"
            className="form-control"
            placeholder="Введите имя"
            value={searchName}
            onChange={(e) => setSearchName(e.target.value)}
          />
        </div>

        <div>
          <label className="form-label">Поиск по email</label>
          <input
            type="text"
            className="form-control"
            placeholder="Введите email"
            value={searchEmail}
            onChange={(e) => setSearchEmail(e.target.value)}
          />
        </div>

        {isAdmin && (
          <>
            <button className="btn-skyblue btn-fixed-width" onClick={startAdd}>Добавить лид</button>
            <button className="btn-skyblue btn-fixed-width" onClick={startAddUser}>Добавить пользователя</button>
          </>
        )}
        <a className="btn-skyblue btn-fixed-width" href="/statistics">Статистика</a>
        {isAdmin && (
          <>
            <ExcelUpload className="btn-skyblue btn-fixed-width" onUpload={onExcelUpload} />
            <ExcelExport className="btn-skyblue btn-fixed-width" onExport={handleExcelExport} />
          </>
        )}
      </div>   

        {(!leads || leads.length === 0) && (
          <p className="text-muted">Лидов пока нет</p>
        )}


      {adding && (
        <div className="table-scroll-wrapper">
        <table className="table table-bordered mb-3">
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col.id}>{col.label}</th>
              ))}              
            </tr>
          </thead>
          <tbody>
            <tr>
              {columns.map((col) => (
                <td key={`new-${col.id}`} style={{ minWidth: col.width || 'auto' }}>
                  {col.id === 'datetime' ? (
                    new Date(newLeadData[col.id]).toLocaleString()
                  ) : col.id === 'status' ? (
                    <select
                      className="form-control"
                      value={newLeadData[col.id]}
                      onChange={(e) =>
                        setNewLeadData((prev) => ({ ...prev, [col.id]: e.target.value }))
                      }
                    >
                      <option value="New">New</option>
                      <option value="NA">NA</option>
                      <option value="NI">NI</option>
                      <option value="Wrong">Wrong</option>
                      <option value="Unaviable">Unaviable</option>
                      <option value="Depositor">Depositor</option>
                      <option value="VM">VM</option>
                      <option value="HU">HU</option>
                      <option value="Callback">Callback</option>
                      <option value="Replace">RP</option>
                      <option value="Double">Double</option>
                      <option value="NoLanguage">No Language</option>
                    </select>
                  ) : col.id === 'country' ? (
                    <select
                      className="form-control"
                      value={newLeadData[col.id]}
                      onChange={(e) =>
                        setNewLeadData((prev) => ({ ...prev, [col.id]: e.target.value }))
                      }
                    >
                      {countries.map((c) => (
                        <option key={c} value={c}>{c}</option>
                      ))}
                    </select>
                  ) : (
                    <textarea                      
                      className="form-control"
                      value={lead[col.id] || ''}
                      readOnly
                      rows={6}
                    />
                  )}
                </td>
              ))}
              <td>
                <button className="btn btn-success btn-sm me-1" onClick={saveAdd} disabled={loading}>Сохранить</button>
                <button className="btn btn-secondary btn-sm" onClick={cancelAdd} disabled={loading}>Отмена</button>
              </td>
            </tr>
          </tbody>
        </table>
        </div>
      )}

      <LeadModal
        show={showModal}
        onHide={closeModal}
        onSave={saveAdd}
        newLeadData={newLeadData}
        setNewLeadData={setNewLeadData}
        loading={loading}
      />
      
      <AddUserModal
                show={showUserModal}
                onHide={closeUserModal}
                onSave={saveUser}
                userData={userData}
                setUserData={setUserData}
                loading={loading}
      />
      
      <div className="mb-3 d-flex align-items-center gap-3">
        <div>
          <label htmlFor="statusFilter" className="form-label mb-0">Фильтр по статусу:</label>
          <select
            id="statusFilter"
            className="form-select"
            style={{ width: '180px' }}
            value={selectedStatusFilter}
            onChange={(e) => setSelectedStatusFilter(e.target.value)}
          >
            <option value="">Все</option>
            <option value="New">New</option>
            <option value="NA">NA</option>
            <option value="NI">NI</option>
            <option value="Wrong">Wrong</option>
            <option value="Unaviable">Unaviable</option>
            <option value="Depositor">Depositor</option>
            <option value="VM">VM</option>
            <option value="HU">HU</option>
            <option value="Callback">Callback</option>
            <option value="Replace">RP</option>
            <option value="Double">Double</option>
            <option value="NoLanguage">No Language</option>
          </select>
        </div>

        <div>
          <label htmlFor="sourceFilter" className="form-label mb-0">Фильтр по источнику:</label>
          <select
            id="sourceFilter"
            className="form-select"
            style={{ width: '180px' }}
            value={selectedSourceFilter}
            onChange={(e) => setSelectedSourceFilter(e.target.value)}
          >
            <option value="">Все</option>
            {[...new Set(leads.map((l) => l.source).filter(Boolean))].map((src) => (
              <option key={src} value={src}>{src}</option>
            ))}
          </select>
        </div>

        <div>
          <label htmlFor="managerFilter" className="form-label mb-0">Фильтр по менеджеру:</label>
          <select
            id="managerFilter"
            className="form-select"
            style={{ width: '180px' }}
            value={selectedManagerFilter}
            onChange={(e) => setSelectedManagerFilter(e.target.value)}
          >
            <option value="">Все</option>
            {[...new Map(leads
              .filter(l => l.manager)  // фильтруем лиды, где менеджер не null
              .map(l => [l.manager.id, l.manager]) // создаём пары [id, объект]
            ).values()].map((mgr) => (
              <option key={mgr.id} value={mgr.id}>
                {mgr.name}
              </option>
            ))}
          </select>
        </div>


      </div>


      <DragDropContext onDragEnd={handleDragEnd}>
        <div className="table-scroll-wrapper">
        <table className="table table-bordered">
          <thead>
            <Droppable droppableId="columns" direction="horizontal" type="column">
              {(provided) => (
                <tr ref={provided.innerRef} {...provided.droppableProps}>
                  {columns.map((col, index) => (  
                    <Draggable draggableId={col.id} index={index} key={col.id}>
                      {(provided) => (
                        <th
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          style={{
                            ...provided.draggableProps.style,
                            cursor: 'move',
                            userSelect: 'none',
                            whiteSpace: 'nowrap',
                            minWidth: col.width || 'auto',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }}
                          >
                            <span
                              onClick={() =>
                                ['country', 'source', 'manager'].includes(col.id) && handleSort(col.id)
                              }
                              style={{
                                cursor: ['country', 'source', 'manager'].includes(col.id)
                                  ? 'pointer'
                                  : 'default',
                                flexGrow: 1,
                              }}
                            >
                              {col.label}
                              {sortConfig.key === col.id && (
                                <span style={{ marginLeft: 4 }}>
                                  {sortConfig.direction === 'asc' ? '▲' : '▼'}
                                </span>
                              )}
                            </span>
                           <span
                              {...provided.dragHandleProps}
                              title="Перетащить"
                              style={{
                                marginLeft: 8,
                                cursor: 'grab',
                                fontSize: '0.9em',
                                color: '#888',
                              }}
                            >
                              ☰
                            </span>
                          </div>
                        </th>
                      )}
                    </Draggable>
                  ))}                  
                </tr>
              )}
            </Droppable>
          </thead>

         <tbody>
            {currentLeads.map((lead, index) => (
              <tr key={lead.id} className={getRowClass(lead.status)}>
                {columns.map((col) => (
                  <td key={`${lead.id}-${col.id}`} style={{ minWidth: col.width || 'auto' }}>
                    {col.id === 'index' ? (
                        (currentPage - 1) * leadsPerPage + index + 1
                      ) : editingId === lead.id ? (
                      col.id === 'datetime' ? (
                        new Date(editData[col.id]).toLocaleString()
                      ) : col.id === 'status' ? (
                        //(isAdmin || lead.managerId === user.id || lead.manager?.id === user.id) ? (
                        <select
                          className="form-control"
                          value={editData[col.id] || lead[col.id]}  // сначала используем editData, если есть
                            onChange={async (e) => {
                              const newStatus = e.target.value;
                              setEditData((prev) => ({ ...prev, status: newStatus })); // ⬅️ обновляем editData!

                              const updatedLead = { ...lead, status: newStatus };
                              try {
                                setLoading(true);
                                await onSave(updatedLead); // сохраняем немедленно, как раньше
                              } catch (err) {
                                console.error('Ошибка при обновлении статуса:', err);
                                setError('Ошибка при обновлении статуса');
                              } finally {
                                setLoading(false);
                              }
                            }}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                        >
                          <option value="New">New</option>
                          <option value="NA">NA</option>
                          <option value="NI">NI</option>
                          <option value="Wrong">Wrong</option>
                          <option value="Unaviable">Unaviable</option>
                          <option value="Depositor">Depositor</option>
                          <option value="VM">VM</option>
                          <option value="HU">HU</option>
                          <option value="Callback">Callback</option>
                          <option value="Replace">RP</option>
                          <option value="Double">Double</option>
                          <option value="NoLanguage">No Language</option>
                        </select>//) : (
                          //<span>{lead.status}</span>
                        //)
                      ) : col.id === 'country' ? (
                        <select
                          className="form-control"
                          value={editData[col.id]}
                          onChange={(e) =>
                            setEditData({ ...editData, [col.id]: e.target.value })
                          }
                        >
                          {countries.map((c) => (
                            <option key={c} value={c}>
                              {c}
                            </option>
                          ))}
                        </select>
                      ) : col.id === 'attention' ? (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                          <label
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '6px',
                              fontSize: '0.85rem',
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={!!editData.isPinned}
                              onChange={(e) =>
                                setEditData((prev) => ({
                                  ...prev,
                                  isPinned: e.target.checked,
                                }))
                              }
                            />
                            <span>Важно для менеджера</span>
                          </label>

                          <textarea
                            className="form-control form-control-sm"
                            placeholder="Заметка для менеджера"
                            rows={4}
                            style={{ resize: 'vertical' }}
                            value={editData.pinnedComment || ''}   
                            onChange={(e) =>
                              setEditData((prev) => ({
                                ...prev,
                                pinnedComment: e.target.value,
                              }))
                            }
                          />
                        </div>)
                      
                      : col.id === 'manager' ? (
                        <select
                          className="form-control"
                          value={editData.managerId || ''}
                          onChange={(e) => {
                            const selectedId = parseInt(e.target.value);
                            const selectedManager = managers.find(m => m.id === selectedId);
                            setEditData({
                              ...editData,
                              managerId: selectedId,
                              manager: selectedManager || null, // добавляем весь объект менеджера
                            });
                          }}
                        >
                          <option value="">—</option>
                          {managers.map((m) => (
                            <option key={m.id} value={m.id}>
                              {m.name}
                            </option>
                          ))}
                        </select>
                      ) : col.id === 'kommentarOperator' ? (
                        //canEdit(lead) ? (
                        <div style={{ position: 'relative'}}>                          
                            <textarea
                              style={{ width: '100%', whiteSpace: 'pre-wrap', resize: 'vertical'}}//col.width || (col.id === 'kommentarOperator' ? '300px' : 'auto') }}
                              className="form-control"
                              value={editData[col.id] || ''}
                              onChange={(e) =>
                                setEditData({ ...editData, [col.id]: e.target.value })
                              }
                              rows={6}
                            />                                              
                        </div>//) : (
                          //<textarea
                            //className="form-control"
                            //value={lead[col.id] || ''}
                            //readOnly
                            //rows={4}
                            //style={{ width: '100%', whiteSpace: 'pre-wrap' }}
                          ///>
                        //)
                      ) : col.id === 'actions' && isAdmin ? (
                      <div className="actions-column">
                        {editingId === lead.id ? (
                          <>
                            <button
                              className="btn btn-success btn-sm me-1"
                              onClick={saveEdit}
                              disabled={loading}
                            >
                              Сохранить
                            </button>
                            <button
                              className="btn btn-secondary btn-sm"
                              onClick={cancelEdit}
                              disabled={loading}
                            >
                              Отмена
                            </button>
                          </>
                        ) : (
                          <>
                            <button
                              className="btn btn-primary btn-sm me-1"
                              onClick={() => startEdit(lead)}
                            >
                              Редактировать
                            </button>
                            <button
                              className="btn btn-danger btn-sm"
                              onClick={() => deleteLead(lead.id)}
                              disabled={loading}
                            >
                              Удалить
                            </button>
                          </>
                        )}
                      </div>
                    ) : col.id !== 'actions' && (
                      <textarea
                        className="form-control"
                        value={editData[col.id] || ''}
                        onChange={(e) =>
                          setEditData((prev) => ({ ...prev, [col.id]: e.target.value }))
                        }
                        rows={4}
                      />
                    )
                    ) : col.id === 'datetime' ? (
                      new Date(lead[col.id]).toLocaleString()

                      ) : col.id === 'attention' ? (
                        // 🔴 Наша новая колонка
                        isAdmin ? (
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                          <label style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <input
                              type="checkbox"
                              checked={!!lead.isPinned}
                              onChange={async (e) => {
                                const newIsPinned = e.target.checked;
                                const updatedLead = {
                                  ...lead,
                                  isPinned: newIsPinned,
                                };

                                try {
                                  setLoading(true);
                                  setError(null);
                                  await onSave(updatedLead);
                                  lead.isPinned = newIsPinned;
                                  if (onRefresh) {
                                    await onRefresh();
                                  }
                                } catch (err) {
                                  console.error('Ошибка при обновлении pin:', err);
                                  setError('Ошибка при обновлении pin');
                                } finally {
                                  setLoading(false);
                                }
                              }}
                            />
                            <span>Поднять</span>
                          </label>

                          <textarea
                            className="form-control form-control-sm"
                            placeholder="Заметка для менеджера"
                            defaultValue={lead.pinnedComment || ''}
                            rows={3}
                            style={{ resize: 'vertical' }}
                            onBlur={async (e) => {
                              const newComment = e.target.value;
                              const oldComment = lead.pinnedComment || '';

                              if (newComment === oldComment) return;

                              const updatedLead = {
                                ...lead,
                                pinnedComment: newComment,
                              };

                              try {
                                setLoading(true);
                                setError(null);
                                await onSave(updatedLead);
                                lead.pinnedComment = newComment;
                                if (onRefresh) {
                                  await onRefresh();
                                }
                              } catch (err) {
                                console.error('Ошибка при обновлении заметки:', err);
                                setError('Ошибка при обновлении заметки');
                              } finally {
                                setLoading(false);
                              }
                            }}
                          />
                        </div>
                        ) : (
                          // Вид менеджера
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                          {lead.isPinned && (
                            <span style={{ fontWeight: 'bold', color: '#c0392b' }}>
                              ⚠ Важно
                            </span>
                          )}
                          {lead.pinnedComment && (
                            <span style={{ fontSize: '0.8rem', whiteSpace: 'pre-wrap' }}>
                              {lead.pinnedComment}
                            </span>
                          )}
                        </div>
                        )

                      ) : col.id === 'status' ? (
                    //(isAdmin || lead.managerId === user.id || lead.manager?.id === user.id) ? 
                    //(
                        <Select
                          value={statusOptions.find(opt => opt.value === lead.status)}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          onChange={async (selected) => {
                            const updatedLead = { ...lead, status: selected.value };
                            try {
                              setLoading(true);
                              await onSave(updatedLead);
                              lead.status = selected.value;
                              setEditData({ ...editData });
                            } catch (err) {
                              console.error('Ошибка при обновлении статуса:', err);
                              setError('Ошибка при обновлении статуса');
                            } finally {
                              setLoading(false);
                            }
                          }}
                          options={statusOptions}
                          styles={customStyles}
                          formatOptionLabel={formatOptionLabel}
                        />
                      ) //: (
                          //<span>{lead.status}</span>
                        //) ) 
                        : col.id === 'manager' ? (
                      lead.manager?.name || ''
                    ) : col.id === 'kommentarOperator' ? (
                      //canEdit(lead) ? (
                      <div style={{ position: 'relative'}}>                        
                          <textarea
                            style={{ width: '100%', whiteSpace: 'pre-wrap', resize: 'vertical' }}//col.width || (col.id === 'kommentarOperator' ? '300px' : 'auto') }}
                            className="form-control"
                            defaultValue={lead[col.id] || ''}
                            onBlur={async (e) => {
                              const newValue = e.target.value;
                              if (newValue !== lead[col.id]) {
                                const updatedLead = { ...lead, kommentarOperator: newValue };
                                try {
                                  setLoading(true);
                                  await onSave(updatedLead);
                                  lead.kommentarOperator = newValue; 
                                } catch (err) {
                                  console.error('Ошибка при обновлении комментария:', err);
                                  setError('Ошибка при обновлении комментария');
                                } finally {
                                  setLoading(false);
                                }
                              }
                            }}
                            rows={6}
                          />                                         
                      </div>
                    //) : (
                          //<textarea
                            //className="form-control"
                            //value={lead[col.id] || ''}
                            //readOnly
                            //rows={4}
                            //style={{ width: '100%', whiteSpace: 'pre-wrap' }}
                          ///>
                        )//)
                    : isAdmin && col.id === 'actions' ? (<td className="actions-column">
                  {editingId === lead.id ? (
                    <>
                      <button
                        className="btn btn-success btn-sm me-1"
                        onClick={saveEdit}
                        disabled={loading}
                      >
                        Сохранить
                      </button>
                      <button
                        className="btn btn-secondary btn-sm"
                        onClick={cancelEdit}
                        disabled={loading}
                      >
                        Отмена
                      </button>
                    </>
                  ) : (
                    <>
                      {isAdmin && (
                        <>
                          <button
                            className="btn btn-primary btn-sm me-1"
                            onClick={() => startEdit(lead)}
                          >
                            Редактировать
                          </button>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => deleteLead(lead.id)}
                            disabled={loading}
                          >
                            Удалить
                          </button>
                        </>
                      )}
                    </>
                  )}
                </td>
                  ) 
                  :(
                      lead[col.id]
                    )}

                  </td>
                ))}                
              </tr>
            ))}
          </tbody>

        </table>
        </div>
      </DragDropContext>
      <div className="d-flex justify-content-between align-items-center mt-3">
        <div>
          Показать:
          {[25, 50, 100, 200].map((size) => (
            <button
              key={size}
              className={`btn btn-sm ms-2 ${leadsPerPage === size ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => {
                setLeadsPerPage(size);
                setCurrentPage(1); 
              }}
            >
              {size}
            </button>
          ))}
        </div>

        <div>
          Страница:
          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i}
              className={`btn btn-sm ms-2 ${currentPage === i + 1 ? 'btn-secondary' : 'btn-outline-secondary'}`}
              onClick={() => setCurrentPage(i + 1)}
            >
              {i + 1}
            </button>
          ))}
        </div>
      </div>
        
    </>
  );
}

export default LeadList;
